import React from "react";
import { Card, CardContainer } from "../../../components/Card";
import { Box, Typography, useTheme } from "@mui/material";
import {
    BarChart,
    HorizontalBarChart,
    PieChart,
} from "../../../components/Charts";
import PostCarousel from "../../../components/PostCarousel";

function Posts({ data, platform }) {
    const theme = useTheme();

    // Function to format numbers with appropriate units (K, M, B, T)
    const formatNumber = (num) => {
        if (num === null || num === undefined || isNaN(num)) {
            return "0";
        }

        const absNum = Math.abs(num);

        if (absNum >= 1e12) {
            return (num / 1e12).toFixed(1) + "T";
        } else if (absNum >= 1e9) {
            return (num / 1e9).toFixed(1) + "B";
        } else if (absNum >= 1e6) {
            return (num / 1e6).toFixed(1) + "M";
        } else if (absNum >= 1e3) {
            return (num / 1e3).toFixed(1) + "K";
        } else {
            return num.toString();
        }
    };

    // Calculate average metrics
    const averageLikes = data?.metrics?.likes;
    const averageViews = data?.metrics?.views;
    const averageComments = data?.metrics?.comments;

    // Define metrics to display
    const metricsToDisplay = [
        { name: "Content Count", value: data?.metrics?.contents },
        { name: "Average Likes", value: averageLikes },
        { name: "Average Views", value: averageViews },
        { name: "Average Comments", value: averageComments },
    ];

    // Define a color mapping for each metric
    const colorMapping = {
        "Content Count": theme.palette.graph.cyan,
        "Average Likes": theme.palette.graph.yellow,
        "Average Views": theme.palette.graph.magenta,
        "Average Comments": theme.palette.graph.purple,
    };

    return (
        <>
            <CardContainer>
                {metricsToDisplay.map((metric) => (
                    <Card key={metric.name}>
                        <Typography
                            variant="h5"
                            sx={{
                                color:
                                    colorMapping[metric.name] ||
                                    theme.palette.graph.cyan,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {formatNumber(metric.value)}
                        </Typography>
                        <Typography
                            variant="captionRegular"
                            sx={{
                                color: theme.palette.neutral[500],
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {metric.name}
                        </Typography>
                    </Card>
                ))}
            </CardContainer>
            <Box className="no-export">
                <PostCarousel
                    data={data?.contents?.top}
                    containerTitle="Top Posts"
                />
            </Box>
            {/* <Box className="no-export">
                <PostCarousel
                    data={data?.contents?.recent}
                    containerTitle="Recent Posts"
                />
            </Box> */}
            {platform === "youtube" ? null : (
                <Box className="no-export">
                    <PostCarousel
                        data={data?.contents?.sponsored}
                        containerTitle="Sponsored Posts"
                    />
                </Box>
            )}
        </>
    );
}

export default Posts;
